import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import Axios from '../../config/axios';
import { toast, confirm } from '@rickylandino/react-messages';
import { Empty, Spin, Alert, Table, Input, Badge } from 'antd';
import { Fragment } from 'react';
import ContactDetailsSlider from './ContactDetailsSlider';

export default function ContractorContactsTab(props) {
    const [state, setState] = useState({
        selectedContractorId: '',
        contacts: [],
        dataLoaded: false,
        contactEditMode: 'Add',
        selectedContactIdx: null,
        selectedContact: {}
    });

    const [showContactDetailsSlider, setShowContactDetailsSlider] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState(['']);
    const [currentPage, setCurrentPage] = useState([1]);
    const [currentPageSize, setCurrentPageSize] = useState([10]);

    useEffect(() => {
        var alive = true;

        if (alive && props.selectedContractorId !== null) {
            Axios.get(`/api/GetContractorContacts`, {
                params: {
                    contractorID: props.selectedContractorId
                }
            }).then(response => {
                let contactsList = response.data;

                setState({
                    ...state,
                    contacts: contactsList,
                    dataLoaded: true,
                    selectedContractorId: props.selectedContractorId
                });
            }).catch(error => {
                console.log(error);
            });
        }
        return () => {
            alive = false;
        };

    }, []);

    const columns = [
        {
            dataIndex: 'contacts_ID',
            title: 'contacts_ID',
            key: 'contacts_ID',
            hidden: true
        }, {
            dataIndex: 'contactName',
            title: 'Contact Name',
            key: 'contactName',
            sorter: (a, b) => a.contactName.localeCompare(b.contactName)
        }, {
            dataIndex: 'contactTitle',
            title: 'Title',
            key: 'contactTitle',
            sorter: (a, b) => a.contactTitle.localeCompare(b.contactTitle)
        }, {
            title: 'Contact Details',
            key: 'action',
            width: 120,
            render: (record) => (
                <span className="hover" onClick={(e) => LoadContactDetails(e, record)}><i id="contactDetails" className="fas fa-edit fa-1x ml-3 text-center hover"></i></span>
            ),
            align: 'center'
        }, {
            title: 'Delete Contact',
            key: 'action2',
            width: 120,
            render: (record) => (
                <i id="deleteContact" className="far fa-trash-alt fa-1x ml-3 text-center hover text-danger" onClick={(e) => handleDeleteContact(e, record)}></i>
            ),
            align: 'center'
        }
    ].filter(item => !item.hidden);

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: 0, // Set the width to 0
        renderCell: () => "", // Render nothing inside
    };

    function LoadContactDetails(e, record) {
        Axios.get(`/api/GetContactById`, {
            params: {
                contactID: record.contacts_ID
            }
        }).then(response => {
            setShowContactDetailsSlider(true);

            setState({
                ...state,
                //selectedContactIdx: rowIndex,
                selectedContact: response.data,
                selectedContactId: record.contacts_ID,
            });
        }).catch(error => {
            console.log(error);
        });
    }

    function handleAddContact() {
        setState({
            ...state,
            buttonLabel: 'Save New Contact',
            modalHeader: 'Add New Contact',
            contactEditMode: 'Add',
            formFields: {},
            selectedContactId: null,
            selectedContactName: ''
        });

        setShowContactDetailsSlider(true);
    }

    function handleDeleteContact(e, record) {
        confirm({
            title: "You are about to permanently delete this Contact",
            content: "Are you sure you would like continue?",
            buttons: ["Yes", "No"],
        }, (buttonPressed) => {
            if (buttonPressed === 'Yes') {
                Axios.post(`/api/DeleteContact`, record
                ).then(response => {
                    if (response.data) {
                        toast.success("Contact has been deleted");

                        setShowContactDetailsSlider(false);
                        setState({
                            ...state,
                            contacts: response.data,
                        });
                    }
                }).catch(error => {
                    console.log(error);
                });

                return 0;
            } else {
                return 0;
            }
        });
    }

    async function updateTableDisplay(contacts, idxToDirectTo = null) {
        var myPageSize = 10;
        var myPageIndex = 1;

        await setState({ ...state, dataLoaded: false });

        for (let i = 0; i < contacts.length; i++) {
            if (contacts[i].contacts_ID === contacts[idxToDirectTo].contacts_ID) {
                myPageIndex = Math.floor(i / myPageSize) + 1
                break;
            }
        }

        updatePageState(myPageIndex, myPageSize);

        //now set the selected Contractor
        let selRows = [contacts[idxToDirectTo].contacts_ID];
        setSelectedRowKeys([...selRows]);

        setShowContactDetailsSlider(false);
        setState({
            ...state,
            contacts,
            selectedContact: contacts[idxToDirectTo],
            dataLoaded: true
        });
    }

    function updatePageState(page, pageSize) {
        setCurrentPage(page);
        setCurrentPageSize(pageSize);

        setState({
            ...state,
        });
    }

    return (
        <div>
            <Card className="local777Card">
                <Card.Header><span>Contractor Contacts</span></Card.Header>
                <Card.Body>
                    <div className="panel-hdr noTitle">
                        <button type="button" className="btn btn-submit margin-0-10" onClick={handleAddContact}>
                            Add Contact
                        </button>
                    </div>
                    <div>
                        {state.dataLoaded &&
                            <Fragment>
                                {state.contacts.length === 0 ?
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                        <span>
                                            No Contacts Found For This Contractor
                                        </span>
                                    } />
                                    :
                                    <Table className="custom-ant-selection"
                                        rowKey={item => item.contacts_ID}
                                        rowSelection={rowSelection}
                                        hideSelectionColumn={true}
                                        bordered
                                        size="small"
                                        dataSource={state.contacts}
                                        style={{ whiteSpace: 'pre' }}
                                        columns={columns}
                                        pagination={{
                                            defaultPageSize: 10,
                                            showSizeChanger: true,
                                            pageSizeOptions: ['10', '25', '50', '100'],
                                            showTotal: (total, range) => (
                                                <span className="color-dark-blue" style={{ left: 0, position: "absolute", fontSize: "large", fontWeight: "bold" }}>
                                                    Showing {range[0]}-{range[1]} of {total}
                                                </span>
                                            ),
                                            onChange: (page, pageSize) => {
                                                updatePageState(page, pageSize);
                                            },
                                            current: currentPage,
                                            pageSize: currentPageSize
                                        }}
                                        onRow={(record) => {
                                            return {
                                                onClick: () => {
                                                    let selRows = [record.contacts_ID];
                                                    setSelectedRowKeys([...selRows]);
                                                },
                                                onDoubleClick: (e) => {
                                                    LoadContactDetails(e, record);
                                                }
                                            }
                                        }}
                                    />
                                }
                            </Fragment>
                        }
                    </div>
                    {showContactDetailsSlider &&
                        <ContactDetailsSlider showPane={showContactDetailsSlider} selectedContactId={state.selectedContactId} contacts={state.contacts} selectedContractorId={state.selectedContractorId}
                            selectedIdx={state.selectedIdx} updateTableDisplay={updateTableDisplay} hidePane={() => setShowContactDetailsSlider(false)} />
                    }
                </Card.Body>
            </Card>
        </div>
    );
}